import { makeStyles } from 'tss-react/mui'
import { nunito_sans } from '@styles/fonts'
const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    maxWidth: '1140px',
    margin: ' auto',
  },
  text: {
    margin: theme.spacing(40, 0, 30, 0),
    fontFamily: nunito_sans.style.fontFamily,
    fontWeight: 800,
    fontSize: '36px',
    lienHeight: '49.1px',
    textAlign: 'center',
    textTransform: 'uppercase',

    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lienHeight: '21.82px',
      margin: theme.spacing(25, 0, 20, 0),
    },
  },
  zenModeText: {
    margin: theme.spacing(20, 0, 30, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0, 0, 15, 0),
    },
  },
}))

export default useStyles
